/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".global-footer .footer-learn-more ul li{border:none!important}.footer-learn-more a{text-decoration:underline!important}"];
export { styles as styles };
